export const url = "https://dev-dl.tdcx.com:3092/";

export const 
login = url + 'login',//post
dashboard = url +'dashboard',
tasks = url + 'tasks', //Get all tasks
postTasks = url + 'tasks',
editTask = url + 'tasks',
deleteTask = url + 'tasks'
